import React, { useState } from 'react';
import { Popup } from '../../components/Popup';
import { Button } from '../../components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { createOfficeExpense } from '../../redux/officeSlice';
import { Input } from '../../components/Input';
import { Select } from '../../components/Select';

export const CreateExpense = ({closeFn, city, monthStamp }) => {

    const dispatch = useDispatch();

    const expenseCategories = useSelector((state) => state.settings.expenseCategories);
    const [category, setCategory] = useState(expenseCategories[0]?._id);
    const [amount, setAmount] = useState('');
    const [comment, setComment] = useState('');

    const createExpenseHandler = () => {
        if (!amount || isNaN(+amount) || +amount <= 0) return;
        dispatch(createOfficeExpense({amount: +amount, category, city, monthStamp, comment}));
        closeFn();
    }

    return (
        <Popup
            title='Добавить расход'
            closeFn={closeFn}
            button={<Button text={`Добавить`} onClick={createExpenseHandler} />}>
            <div className='office__create-expense'>
                <Input label='Сумма' value={amount} changeHandler={(evt) => setAmount(evt.target.value)}/>
                {expenseCategories.length &&
                <label>
                    <span>Категория</span>
                    <Select enums={expenseCategories} value={category} changeHandler={(evt) => setCategory(evt.target.value)}/>
                </label>}
                <Input label='Коммент' placeholder='Необязательно' value={comment} changeHandler={(evt) => setComment(evt.target.value)}/>
            </div>
        </Popup>
    );
};
